/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm, theme } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import { ApplicationEnv } from "~/models";
import { generateActionSuccessText, useAxios } from "~/tools";

type ApplicationEnvironmentDeleteProps = {
  environment: ApplicationEnv;
  deleteCallback: () => void;
};

function ApplicationEnvironmentDelete({
  environment,
  deleteCallback,
}: ApplicationEnvironmentDeleteProps) {
  const { showError } = useShowError();
  const { Axios } = useAxios();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <Button
        mt={theme.spacing.spacing01}
        icon="trash"
        size="sm"
        onClick={() => {
          setIsOpen(true);
        }}
        severity="low"
      >
        Delete from Overlay
      </Button>
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            await Axios().delete(`/environments/${environment?.id}`);
            setIsOpen(true);
            showSuccess(
              generateActionSuccessText(`The ${environment?.name}`)()(
                "deleted"
              )()
            );
            deleteCallback();
          } catch (e) {
            showError(e.response);
          } finally {
            setIsOpen(false);
          }
        }}
        actionLabel="Delete"
        contentLabel="Delete Environment"
      >
        Deleting environment {environment?.name} will prevent synchronizing it
        again from Klarity.
      </ModalConfirm>
    </>
  );
}

export { ApplicationEnvironmentDelete };
